import { SearchProps } from '~components/form-fields/search';

import { selectLookupAppointmentServiceTypes } from '~appointments/selectors/serviceTypes';
import { selectAppointmentStatuses } from '~appointments/selectors/statuses';
import { selectClientPackages } from '~main/selectors/clients/clientPackages';
import { isEncryptionEnabled } from '~libs/encryptionSettings';

export const commonFields: SearchProps = {
  text_search: {
    persist: true,
    type: 'text-like',
    field: ['client.full_name', 'user.full_name', 'reference_number', 'client.referrer_name', 'package_fixed.name'],
    placeholder: 'Basic search',
    hidden: isEncryptionEnabled,
  },
  client_name: {
    type: 'text-like',
    field: 'client.full_name',
    placeholder: 'Search client',
    caption: 'Client',
    hidden: isEncryptionEnabled,
  },
  reference_number: {
    type: 'text-like',
    field: 'reference_number',
    placeholder: 'Search reference',
    caption: 'Reference',
  },
  date: {
    defaultShow: true,
    type: 'date-range',
    field: 'date',
    caption: 'Date',
  },
  start_time: {
    type: 'time-range',
    field: 'start_time',
    caption: 'Start Time',
  },
  end_time: {
    type: 'time-range',
    field: 'end_time',
    caption: 'End Time',
  },
  status: {
    type: 'multi-lookup',
    field: 'status_id',
    caption: 'Status',
    placeholder: 'All',
    selectorOptions: selectAppointmentStatuses,
  },
};

export const allFields: SearchProps = {
  ...commonFields,
  worker_name: {
    type: 'text-like',
    field: 'user.full_name',
    placeholder: 'Search care worker',
    caption: 'Care Worker',
  },
  referrer: {
    type: 'text-like',
    field: 'client.referrer_name',
    caption: 'Referrer',
    placeholder: 'Search Referrer',
  },
  client_package: {
    type: 'multi-lookup',
    field: 'package_fixed_id',
    caption: 'Package',
    placeholder: 'All',
    selectorOptions: selectClientPackages,
  },
  service_type: {
    type: 'multi-lookup',
    field: 'service_type_id',
    caption: 'Service Type',
    placeholder: 'All',
    selectorOptions: selectLookupAppointmentServiceTypes,
  },
};

export default commonFields;
